module.exports = __webpack_public_path__ + "img/1.c035b8e9.png";